import { defineComponent as _defineComponent } from 'vue'
import type { Maybe, SingleStepSportEvent, SportOffer } from '@/@types/graphql-types';
import type { SingleStepContext } from '@/features/sports/helpers/config';
import type { ThumborFunction } from '@/filters/thumbor';

import Vue, { computed } from 'vue';

import PictureComp from '@/components/picture/PictureComp.vue';
import EventBackdropPromo from '@/features/sports/components/event/EventBackdropPromo.vue';

import { ClickoutUrl } from '@/helpers/clickout-helper';
import { BuyboxParam } from '@/helpers/offer-helper';
import { SponsoredClickoutsHelper } from '@/features/sponsored-recommendations/helpers/sponsored-clickouts-helper';
import { SnowplowSportContext } from '@/helpers/tracking/providers';
import { useAppStore, useLanguageStore } from '@/helpers/composables/useStores';
import { useSportsPromotion } from '@/features/sports/composables/useSportsPromotion';


export default /*#__PURE__*/_defineComponent({
  __name: 'EventBackdrop',
  props: {
    context: null,
    event: null,
    watchNowOffer: null,
    displayOffer: { type: Boolean }
  },
  emits: ["clickOut"],
  setup(__props: any) {

const props = __props as {
	context: SingleStepContext;
	event: SingleStepSportEvent;
	watchNowOffer?: Maybe<SportOffer>;
	displayOffer?: boolean;
};





const { webLocale, country } = useLanguageStore();
const { xServeTrack } = useAppStore();

const { sportsPromotions } = useSportsPromotion();

const playIcon = `url(/${ASSETS_DIR}/img/justwatch-sports-icon-play.svg)`;

const renderPromo = computed(() => {
	if (sportsPromotions.value == null) return false;

	const isInEventIds = sportsPromotions.value?.promotions.find(promotion =>
		promotion?.eventIds?.includes(props.event?.id)
	);

	const eventOffers = new Set(props.event.offers.map(offer => offer.package.shortName));
	const isInEventOffers = sportsPromotions.value.promotions.some(promo => eventOffers.has(promo.package.shortName));

	return isInEventIds || isInEventOffers;
});

const backdropImage = computed(() =>
	(Vue.filter('Thumbor') as ThumborFunction)({
		url: `/${ASSETS_DIR}/img/sports/jw-sports-backdrop-${props.context.sportType}-scaled.jpeg`,
		imageType: 'backdrop',
		extension: '.webp',
	})
);

const sportContext = computed(() =>
	SnowplowSportContext.fromSportEventV2(props.event.sport, props.event.objectType, props.event)
);

const offerClickoutUrl = computed(() =>
	new ClickoutUrl(props.watchNowOffer)
		.addContexts(sportContext.value)
		.set('uct_country', country.value)
		.set('uct_buybox', BuyboxParam.Sport)
		.set('uct_sport', props.context.sportType)
		.setCanary(xServeTrack.value)
);

const linkRel = computed(() =>
	props.watchNowOffer &&
	SponsoredClickoutsHelper.isSponsoredOfferGraphql(props.watchNowOffer.package.packageId, webLocale.value)
		? 'noopener noreferrer sponsored'
		: 'noopener noreferrer'
);

return { __sfc: true,props, webLocale, country, xServeTrack, sportsPromotions, playIcon, renderPromo, backdropImage, sportContext, offerClickoutUrl, linkRel, PictureComp, EventBackdropPromo }
}

})